import { ErrorType } from "../../../models/HttpError";
import { AppState } from "../../../redux/reducers";

// store 
import * as ContractConceptRelationshipStore from '../../../redux/middleware/ContractConceptRelationship.Middleware';

// models
import { ContractConceptRelationship } from "../../../models/Entities/Contracts/ContractConceptRelationship";

interface IProps {
  ContractId: number;
  formName?: string;
  label?: string;
  itemNumber?: number;
  value?: string | number;
  realized?: boolean;
  triggerAs?: React.ReactNode;
}

interface ConnectedProps {
  // loading
  isLoading: boolean;
  isLoadingSuccessfully: boolean;
  failOnLoading: boolean;

  // updatimg
  isUpdating: boolean;
  isUpdatedSuccessfully: boolean;
  failOnUpdating: boolean;
  
  // create
  isCreating: boolean;
  isCreatedSuccessfully: boolean;
  failOnCreating: boolean;

  error: ErrorType | undefined;
  ConceptRelationships: ContractConceptRelationship[];
  isAdding: boolean;
  successAdding: boolean | undefined;
  CurrentConceptRelationship: ContractConceptRelationship[];
}

interface MedicalServicesDispatchProps {
 getAllContractConceptRelationships: typeof ContractConceptRelationshipStore.actionCreators.getAllContractConceptRelationships;
 createContractConceptRelationship: typeof ContractConceptRelationshipStore.actionCreators.createContractConceptRelationship;
 updateContractConceptRelationship: typeof ContractConceptRelationshipStore.actionCreators.updateContractConceptRelationship;
}

export type Props = IProps & ConnectedProps & MedicalServicesDispatchProps;

export const mapStateToProps = (state: AppState, ownProps: IProps) => ({
    // loading
    isLoading: state.ContractConceptRelationship?.isLoadingAll || false,
    isLoadingSuccessfully: state.ContractConceptRelationship?.successLoadingAll || false,
    failOnLoading: state.ContractConceptRelationship?.failOnLoadingAll || false,

    // updating
    isUpdating: state.ContractConceptRelationship?.isUpdatingOne || false,
    isUpdatedSuccessfully: state.ContractConceptRelationship?.successUpdatingOne || false,
    failOnUpdating: state.ContractConceptRelationship?.failOnUpdatingOne || false,

    // creating
    isCreating: state.ContractConceptRelationship?.isAddingNewOne || false,
    isCreatedSuccessfully: state.ContractConceptRelationship?.successAddingNewOne || false,
    failOnCreating: state.ContractConceptRelationship?.failOnAddingNewOne || false,
    
    error: state.ContractConceptRelationship?.error,
    ConceptRelationships: state.ContractConceptRelationship?.list || [],
    isAdding: state.ContractConceptRelationship?.isAddingNewOne || false,
    successAdding: state.ContractConceptRelationship?.successAddingNewOne,
    CurrentConceptRelationship: ownProps.label
      ? (state.ContractConceptRelationship?.list ?? []).filter(
          (rel) => rel.formConcept === ownProps.label
        )
      : [],
});

export const mapDispatchToProps = {
  ...ContractConceptRelationshipStore.actionCreators,
};